import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-aufgabe-erinnerung-versenden';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungAufgabeErinnerungVersendenEffects {

    VeranstaltungAufgabeErinnerungVersenden$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_AUFGABE_ERINNERUNG_VERSENDEN),
        mergeMap((x: ac.PostVeranstaltungAufgabeErinnerungVersendenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungAufgabeErinnerungVersenden(x.veranstaltungRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungAufgabeErinnerungVersendenErfolgreichAction(result, x.veranstaltungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungAufgabeErinnerungVersendenFehlerAction(error, x.veranstaltungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenCommandService);
        }
        return this.service;
    }
}
